import { useEffect, useMemo } from 'react';
import { useMutationPostSnapshotGeneration } from 'services/monitor/queries';
import { useLocation } from 'react-router-dom';
import useLocalStorage from 'hooks/useLocalStorage';

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const useForceQueryParamRefreshSnapshot = (entityId, queryParamToRefresh) => {
  const query = useQuery();
  const [value, setValue] = useLocalStorage(`capitalise/${queryParamToRefresh}`);
  const { mutate } = useMutationPostSnapshotGeneration();
  const paramExists = useMemo(() => !!query.get(queryParamToRefresh), [query, queryParamToRefresh]);

  useEffect(() => {
    if (entityId && paramExists && !value) {
      setValue(true);
      mutate(entityId);
    }
  }, [entityId, paramExists]);

  return mutate;
};

export default useForceQueryParamRefreshSnapshot;
